import React from 'react';
import { Typography, Paper, Box } from '@mui/material';

const LoginPage: React.FC = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <Paper elevation={3} sx={{ p: 4, maxWidth: 400 }}>
      <Typography variant="h4" textAlign="center" gutterBottom>
        Login
      </Typography>
      <Typography textAlign="center">
        Authentication system will be implemented here.
      </Typography>
    </Paper>
  </Box>
);

export default LoginPage;